module.exports = __webpack_public_path__ + "assets/img/back.46da3f4b.png";